export const environment = {
  envName: "Development",
  production: false,
  apiURL: "https://dev.api.swayam.cloud/v3",
};
